// extracted by mini-css-extract-plugin
module.exports = {"mainBox":"RahiHome_mainBox__KjSyS","more":"RahiHome_more__-0T-7"};